import { createFileRoute } from "@tanstack/react-router";
import AdminImageAudit from "@/pages/admin/AdminImageAudit";

export const Route = createFileRoute("/_adminLayout/admin/image-audit")({
  component: AdminImageAudit,
});
